// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   LegalPage.css — shared for Privacy Policy, Terms, Refund
═══════════════════════════════════════════════════════════ */

.legal {
  min-height: 100vh;
  background: var(--c-cream, #f4efe6);
}

/* ── Hero band ── */
.legal__hero {
  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);
  padding: clamp(5rem, 10vw, 8rem) 0 clamp(2.5rem, 5vw, 4rem);
}
.legal__eyebrow {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: #b85c38;
  margin: 0 0 0.65rem;
}
.legal__title {
  font-family: var(--font-display, "Anton", sans-serif);
  font-size: clamp(2.2rem, 5vw, 3.5rem);
  font-weight: 400;
  color: #fff;
  margin: 0 0 0.75rem;
  line-height: 1.1;
  letter-spacing: 0.02em;
}
.legal__meta {
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
}

/* ── Body ── */
.legal__body {
  max-width: 1260px !important;
  padding-top: clamp(2.5rem, 5vw, 4rem);
  padding-bottom: clamp(3rem, 6vw, 6rem);
}

.legal__intro {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem 2rem;
  margin-bottom: 2.5rem;
  border-left: 4px solid #b85c38;
}
.legal__intro p {
  font-size: 1.02rem;
  color: #1b1b1b;
  line-height: 1.7;
  margin: 0;
}

/* ── Section ── */
.legal__section {
  margin-bottom: 2.5rem;
}
.legal__section h2 {
  font-family: var(--font-serif, "Playfair Display", Georgia, serif);
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e2a1e;
  margin: 0 0 0.85rem;
  padding-bottom: 0.5rem;
  border-bottom: 1.5px solid #e8e3da;
}
.legal__section h3 {
  font-size: 0.92rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 1.25rem 0 0.5rem;
  letter-spacing: 0.01em;
}
.legal__section p {
  font-size: 0.92rem;
  color: #1b1b1b;
  line-height: 1.75;
  margin: 0 0 0.75rem;
}
.legal__section p:last-child {
  margin-bottom: 0;
}

.legal__section ul {
  margin: 0 0 0.85rem 1.25rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.legal__section li {
  font-size: 0.92rem;
  color: #1b1b1b;
  line-height: 1.65;
}
.legal__section li strong {
  color: #1e2a1e;
}

.legal__section a {
  color: #b85c38;
  text-decoration: none;
  border-bottom: 1px solid rgba(184, 92, 56, 0.3);
  transition: border-color 0.15s;
}
.legal__section a:hover {
  border-bottom-color: #b85c38;
}

@media (max-width: 767px) {
  .legal__body {
    padding-top: 2rem;
    padding-bottom: 3rem;
  }
  .legal__intro {
    padding: 1.1rem 1.25rem;
  }
  .legal__section h2 {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LegalPage.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,2DAA2D;AAC7D;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qDAAqD;EACrD,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;AACX;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;AACA;EACE,kEAAkE;EAClE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,+CAA+C;EAC/C,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   LegalPage.css — shared for Privacy Policy, Terms, Refund\n═══════════════════════════════════════════════════════════ */\n\n.legal {\n  min-height: 100vh;\n  background: var(--c-cream, #f4efe6);\n}\n\n/* ── Hero band ── */\n.legal__hero {\n  background: linear-gradient(135deg, #1e2a1e 0%, #2d3e2d 100%);\n  padding: clamp(5rem, 10vw, 8rem) 0 clamp(2.5rem, 5vw, 4rem);\n}\n.legal__eyebrow {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: #b85c38;\n  margin: 0 0 0.65rem;\n}\n.legal__title {\n  font-family: var(--font-display, \"Anton\", sans-serif);\n  font-size: clamp(2.2rem, 5vw, 3.5rem);\n  font-weight: 400;\n  color: #fff;\n  margin: 0 0 0.75rem;\n  line-height: 1.1;\n  letter-spacing: 0.02em;\n}\n.legal__meta {\n  font-size: 0.82rem;\n  color: rgba(255, 255, 255, 0.45);\n  margin: 0;\n}\n\n/* ── Body ── */\n.legal__body {\n  max-width: 1260px !important;\n  padding-top: clamp(2.5rem, 5vw, 4rem);\n  padding-bottom: clamp(3rem, 6vw, 6rem);\n}\n\n.legal__intro {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem 2rem;\n  margin-bottom: 2.5rem;\n  border-left: 4px solid #b85c38;\n}\n.legal__intro p {\n  font-size: 1.02rem;\n  color: #1b1b1b;\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* ── Section ── */\n.legal__section {\n  margin-bottom: 2.5rem;\n}\n.legal__section h2 {\n  font-family: var(--font-serif, \"Playfair Display\", Georgia, serif);\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #1e2a1e;\n  margin: 0 0 0.85rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1.5px solid #e8e3da;\n}\n.legal__section h3 {\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 1.25rem 0 0.5rem;\n  letter-spacing: 0.01em;\n}\n.legal__section p {\n  font-size: 0.92rem;\n  color: #1b1b1b;\n  line-height: 1.75;\n  margin: 0 0 0.75rem;\n}\n.legal__section p:last-child {\n  margin-bottom: 0;\n}\n\n.legal__section ul {\n  margin: 0 0 0.85rem 1.25rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n.legal__section li {\n  font-size: 0.92rem;\n  color: #1b1b1b;\n  line-height: 1.65;\n}\n.legal__section li strong {\n  color: #1e2a1e;\n}\n\n.legal__section a {\n  color: #b85c38;\n  text-decoration: none;\n  border-bottom: 1px solid rgba(184, 92, 56, 0.3);\n  transition: border-color 0.15s;\n}\n.legal__section a:hover {\n  border-bottom-color: #b85c38;\n}\n\n@media (max-width: 767px) {\n  .legal__body {\n    padding-top: 2rem;\n    padding-bottom: 3rem;\n  }\n  .legal__intro {\n    padding: 1.1rem 1.25rem;\n  }\n  .legal__section h2 {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
